module.exports = __webpack_public_path__ + "img/grey.74890955.png";